<template>
  <v-container v-if="personal" fluid>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <personal-info-card-component :personal="personal"></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="font-weight-bold ui-module-titlebar">Registro de media filiación</v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-form v-model="mediaFiliacionForm" ref="form">
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.complexion"
                          :items="getFiliacionByRasgo(6)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                        >
                          <template v-slot:label>Complexión <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.piel"
                          :items="getFiliacionByRasgo(10)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                        >
                          <template v-slot:label>Piel <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cara"
                          :items="getFiliacionByRasgo(5)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Cara <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Cabello</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cabelloCantidad"
                          :items="getFiliacionByRasgo(14)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Cantidad de cabello <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cabelloColor"
                          :items="getFiliacionByRasgo(16)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Color de cabello <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cabelloForma"
                          :items="getFiliacionByRasgo(4)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Forma <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cabelloCalvicie"
                          :items="getFiliacionByRasgo(23)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Calvicie <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cabelloImplantacion"
                          :items="getFiliacionByRasgo(24)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Implantación <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Frente</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.frenteAltura"
                          :items="getFiliacionByRasgo(17)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Altura <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.frenteInclinacion"
                          :items="getFiliacionByRasgo(25)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Inclinación <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.frenteAncho"
                          :items="getFiliacionByRasgo(26)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Ancho <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Cejas</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cejasDireccion"
                          :items="getFiliacionByRasgo(15)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Dirección <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cejasImplantacion"
                          :items="getFiliacionByRasgo(27)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Implantación <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cejasForma"
                          :items="getFiliacionByRasgo(15)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Forma <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.cejasTamano"
                          :items="getFiliacionByRasgo(28)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Tamaño <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Ojos</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.ojosColor"
                          :items="getFiliacionByRasgo(7)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Color <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.ojosForma"
                          :items="getFiliacionByRasgo(20)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Forma <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.ojosTamano"
                          :items="getFiliacionByRasgo(29)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Tamaño <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Nariz</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.narizRaiz"
                          :items="getFiliacionByRasgo(9)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Raíz (profundidad) <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.narizDorso"
                          :items="getFiliacionByRasgo(30)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Dorso <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.narizAncho"
                          :items="getFiliacionByRasgo(31)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Ancho <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.narizBase"
                          :items="getFiliacionByRasgo(32)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Base <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.narizAltura"
                          :items="getFiliacionByRasgo(33)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Altura <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Boca</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.bocaTamano"
                          :items="getFiliacionByRasgo(13)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Tamaño <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.bocaComisuras"
                          :items="getFiliacionByRasgo(34)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Comisuras <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Labios</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.labiosEspesor"
                          :items="getFiliacionByRasgo(35)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Espesor <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.labiosAlturaNasolabial"
                          :items="getFiliacionByRasgo(36)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Altura naso-labial <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.labiosProminencia"
                          :items="getFiliacionByRasgo(37)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Prominencia <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Mentón</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.mentonTipo"
                          :items="getFiliacionByRasgo(38)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Tipo <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.mentonForma"
                          :items="getFiliacionByRasgo(39)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Forma <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.mentonInclinacion"
                          :items="getFiliacionByRasgo(40)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                          validate-on-blur
                        >
                          <template v-slot:label>Inclinación <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-h6">Oreja derecha</div>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="selectedRasgos.orejaForma"
                          :items="getFiliacionByRasgo(41)"
                          item-value="id"
                          item-text="nombre"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                        >
                          <template v-slot:label>Forma <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <div class="text-subtitle-1">Hélix</div>
                        <v-row>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.helixOriginal"
                              :items="getFiliacionByRasgo(42)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Original <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.helixSuperior"
                              :items="getFiliacionByRasgo(43)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Superior <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.helixPosterior"
                              :items="getFiliacionByRasgo(44)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Posterior <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.helixAdherencia"
                              :items="getFiliacionByRasgo(45)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Adherencia <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <div class="text-subtitle-1">Lóbulo</div>
                        <v-row>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.lobuloContorno"
                              :items="getFiliacionByRasgo(46)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Contorno <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.lobuloAdherencia"
                              :items="getFiliacionByRasgo(47)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Adherencia <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.lobuloParticularidad"
                              :items="getFiliacionByRasgo(48)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Particularidad <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="selectedRasgos.lobuloDimension"
                              :items="getFiliacionByRasgo(49)"
                              item-value="id"
                              item-text="nombre"
                              item-color="secondary"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Dimensión <span class="red--text">*</span> </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="3">
                        <v-select
                          v-model="personal.fk_idCatGrupoSanguineo"
                          :items="grupoSanguineo"
                          item-value="id"
                          item-text="title"
                          item-color="secondary"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                        >
                          <template v-slot:label>Tipo de sangre <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model.number="personal.estatura"
                          type="number"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                        >
                          <template v-slot:label>Estatura (cm) <span class="red--text">*</span> </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model.number="personal.peso"
                          type="number"
                          rounded
                          filled
                          dense
                          background-color="primary"
                          color="secondary"
                          :rules="required"
                        >
                          <template v-slot:label>Peso (Kg) <span class="red--text">*</span> </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="1">
                        <v-checkbox v-model="personal.lentes" label="Usa lentes" color="secondary"> </v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="text-h6">Señas particulares</div>
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-btn class="ui-module-btn-solid" @click="addSeniaParticular" color="secondary">Agregar</v-btn>
                  </v-col>
                  <v-col cols="12" v-for="(señaParticular, index) in activeSeniasParticulares" :key="señaParticular._index">
                    <v-card class="ui-module-card" color="primary">
                      <v-card-text>
                        <v-container fluid>
                          <v-row align="center">
                            <v-col cols="1">
                              <v-avatar color="secondary" size="48" class="white--text">
                                {{ index + 1 }}
                              </v-avatar>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="seniasParticulares[señaParticular._index].fk_idCatTipo"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                :items="tipoSenia"
                                item-value="id"
                                item-text="title"
                                hide-details
                                :rules="required"
                              >
                                <template v-slot:label>Tipo <span class="red--text">*</span> </template>
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="seniasParticulares[señaParticular._index].fk_idCatLado"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                :items="ladoSenia"
                                item-value="id"
                                item-text="title"
                                hide-details
                              >
                                <template v-slot:label>Lado <span class="red--text">*</span> </template>
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="seniasParticulares[señaParticular._index].fk_idCatRegion"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                :items="regionSenia"
                                item-value="id"
                                item-text="title"
                                hide-details
                              >
                                <template v-slot:label>Región <span class="red--text">*</span> </template>
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="seniasParticulares[señaParticular._index].fk_idCatVista"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                :items="vistaSenia"
                                item-value="id"
                                item-text="title"
                                hide-details
                              >
                                <template v-slot:label>Vista <span class="red--text">*</span> </template>
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="seniasParticulares[señaParticular._index].fk_idCatCantidad"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                :items="cantidadSenia"
                                item-value="id"
                                item-text="title"
                                hide-details
                              >
                                <template v-slot:label>Cantidad <span class="red--text">*</span> </template>
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-text-field
                                label="Descripción"
                                v-model="seniasParticulares[señaParticular._index].descripcion"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                hide-details
                              ></v-text-field>
                            </v-col>
                            <v-col cols="1">
                              <v-btn text color="error" @click="removeSeniaParticular(señaParticular._index)">Quitar</v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container>
              <v-row>
                <v-col>
                  <v-btn
                    class="ui-module-btn-solid"
                    color="secondary"
                    @click="submit"
                    :loading="loading"
                    :disabled="loading || !mediaFiliacionForm"
                    >Registrar</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { API_DATE_FORMAT } from '@/const'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'

const MEDIA_FILIACION_FIELDS = Object.freeze([
  { key: 'complexion',             rasgoId: 6  },
  { key: 'piel',                   rasgoId: 10 },
  { key: 'cara',                   rasgoId: 5  },
  { key: 'cabelloCantidad',        rasgoId: 14 },
  { key: 'cabelloColor',           rasgoId: 16 },
  { key: 'cabelloForma',           rasgoId: 4  },
  { key: 'cabelloCalvicie',        rasgoId: 23 },
  { key: 'cabelloImplantacion',    rasgoId: 24 },
  { key: 'frenteAltura',           rasgoId: 17 },
  { key: 'frenteInclinacion',      rasgoId: 25 },
  { key: 'frenteAncho',            rasgoId: 26 },
  { key: 'cejasDireccion',         rasgoId: 15 },
  { key: 'cejasImplantacion',      rasgoId: 27 },
  { key: 'cejasForma',             rasgoId: 15 },
  { key: 'cejasTamano',            rasgoId: 28 },
  { key: 'ojosColor',              rasgoId: 7  },
  { key: 'ojosForma',              rasgoId: 20 },
  { key: 'ojosTamano',             rasgoId: 29 },
  { key: 'narizRaiz',              rasgoId: 9  },
  { key: 'narizDorso',             rasgoId: 30 },
  { key: 'narizAncho',             rasgoId: 31 },
  { key: 'narizBase',              rasgoId: 32 },
  { key: 'narizAltura',            rasgoId: 33 },
  { key: 'bocaTamano',             rasgoId: 13 },
  { key: 'bocaComisuras',          rasgoId: 34 },
  { key: 'labiosEspesor',          rasgoId: 35 },
  { key: 'labiosAlturaNasolabial', rasgoId: 36 },
  { key: 'labiosProminencia',      rasgoId: 37 },
  { key: 'mentonTipo',             rasgoId: 38 },
  { key: 'mentonForma',            rasgoId: 39 },
  { key: 'mentonInclinacion',      rasgoId: 40 },
  { key: 'orejaForma',             rasgoId: 41 },
  { key: 'helixOriginal',          rasgoId: 42 },
  { key: 'helixSuperior',          rasgoId: 43 },
  { key: 'helixPosterior',         rasgoId: 44 },
  { key: 'helixAdherencia',        rasgoId: 45 },
  { key: 'lobuloContorno',         rasgoId: 46 },
  { key: 'lobuloAdherencia',       rasgoId: 47 },
  { key: 'lobuloParticularidad',   rasgoId: 48 },
  { key: 'lobuloDimension',        rasgoId: 49 },
])

function buildEmptyModel() {
  return Object.fromEntries(MEDIA_FILIACION_FIELDS.map((f) => [f.key, null]))
}

export default {
  components: {
    PersonalInfoCardComponent,
  },

  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    await this.fetchPersonalById(this.id)
    if (Array.isArray(this.personal?.seniasParticulares)) {
      this.seniasOriginales = this.personal.seniasParticulares.filter((s) => s.estatus)
      this.seniasParticulares = this.seniasOriginales.map((s) => ({
        idPersonalSeniasParticulares: 0,
        fecha: null,
        estatus: true,
        fk_idCatTipo: s.fk_idCatTipo,
        fk_idCatLado: s.fk_idCatLado,
        fk_idCatRegion: s.fk_idCatRegion,
        fk_idCatVista: s.fk_idCatVista,
        fk_idCatCantidad: s.fk_idCatCantidad,
        descripcion: s.descripcion,
      }))
    }
    await this.fetchMediasFiliaciones()
    await this.fetchRasgos()
    await this.fetchTipoSeniaParticular()
    await this.fetchLadoSeniaParticular()
    await this.fetchRegionSeniaParticular()
    await this.fetchVistaSeniaParticular()
    await this.fetchCantidadSeniaParticular()
  },

  data() {
    return {
      selectedRasgos: buildEmptyModel(),
      seniasParticulares: [],
      seniasOriginales: [],
      mediaFiliacionForm: false,
      loading: false,
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('mediaFiliacion', {
      mediaFiliacion: 'getMediasFiliaciones',
    }),
    ...mapGetters('rasgo', {
      rasgos: 'getRasgos',
    }),
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters('grupoSanguineo', {
      grupoSanguineo: 'getGrupoSanguineo',
    }),
    ...mapGetters('tipoSeniaParticular', {
      tipoSenia: 'getTipoSeniaParticular',
    }),
    ...mapGetters('ladoSeniaParticular', {
      ladoSenia: 'getLadoSeniaParticular',
    }),
    ...mapGetters('regionSeniaParticular', {
      regionSenia: 'getRegionSeniaParticular',
    }),
    ...mapGetters('vistaSeniaParticular', {
      vistaSenia: 'getVistaSeniaParticular',
    }),
    ...mapGetters('cantidadSeniaParticular', {
      cantidadSenia: 'getCantidadSeniaParticular',
    }),

    activeSeniasParticulares() {
      return this.seniasParticulares
        .map((s, index) => ({ ...s, _index: index }))
        .filter((s) => s.estatus)
    },

    activeMediafiliacionByRasgo() {
      if (!this.personal?.mediafiliacion?.length || !this.mediaFiliacion.length) return {}
      const result = {}
      for (const record of this.personal.mediafiliacion) {
        if (!record.estatus) continue
        const catalogEntry = this.mediaFiliacion.find((f) => f.id === record.fk_idMediafiliacion)
        if (catalogEntry) {
          result[catalogEntry.fk_idRasgo] = record.fk_idMediafiliacion
        }
      }
      return result
    },
  },

  watch: {
    activeMediafiliacionByRasgo: {
      immediate: true,
      handler(map) {
        if (!Object.keys(map).length) return
        this.hydrateFromPersonal(map)
      },
    },
  },

  methods: {
    ...mapActions('rasgo', ['fetchRasgos']),
    ...mapActions('mediaFiliacion', ['fetchMediasFiliaciones']),
    ...mapActions('personal', ['fetchPersonalById', 'updatePersonal']),
    ...mapActions('tipoSeniaParticular', ['fetchTipoSeniaParticular']),
    ...mapActions('ladoSeniaParticular', ['fetchLadoSeniaParticular']),
    ...mapActions('regionSeniaParticular', ['fetchRegionSeniaParticular']),
    ...mapActions('vistaSeniaParticular', ['fetchVistaSeniaParticular']),
    ...mapActions('cantidadSeniaParticular', ['fetchCantidadSeniaParticular']),

    getFiliacionByRasgo(id_rasgo) {
      return this.mediaFiliacion.filter((f) => f.fk_idRasgo == id_rasgo)
    },

    hydrateFromPersonal(map) {
      for (const { key, rasgoId } of MEDIA_FILIACION_FIELDS) {
        if (map[rasgoId] !== undefined) {
          this.selectedRasgos[key] = map[rasgoId]
        }
      }
      this.$nextTick(() => {
        this.$refs.form?.validate()
      })
    },

    async submit() {
      this.loading = true
      try {
        const mediafiliacion = this.personal.mediafiliacion ?? []

        for (const record of mediafiliacion) {
          record.estatus = false
        }

        for (const { key } of MEDIA_FILIACION_FIELDS) {
          if (this.selectedRasgos[key] !== null) {
            mediafiliacion.push({
              idPersonalMediafiliacion: 0,
              fecha: moment().format(API_DATE_FORMAT),
              estatus: true,
              fk_idMediafiliacion: this.selectedRasgos[key],
            })
          }
        }

        this.personal.mediafiliacion = mediafiliacion

        const seniasDesactivadas = this.seniasOriginales.map((s) => ({ ...s, estatus: false }))
        const seniasNuevas = this.seniasParticulares.filter((s) => s.estatus)
        this.personal.seniasParticulares = [...seniasDesactivadas, ...seniasNuevas]

        await this.updatePersonal(this.personal)
        this.$router.push('/personal/personal')
      } finally {
        this.loading = false
      }
    },

    addSeniaParticular() {
      this.seniasParticulares.push({
        fecha: null,
        estatus: true,
        fk_idCatTipo: null,
        fk_idCatLado: null,
        fk_idCatRegion: null,
        fk_idCatVista: null,
        fk_idCatCantidad: null,
        descripcion: '',
        idPersonalSeniasParticulares: 0,
      })
    },

    removeSeniaParticular(index) {
      this.$set(this.seniasParticulares, index, { ...this.seniasParticulares[index], estatus: false })
    },
  },
}
</script>

<style scoped>
::v-deep .v-select .v-input__control > .v-input__slot,
::v-deep .v-text-field .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 238, 90, 111), 0.22) !important;
  border-radius: 12px !important;
  transition: all 0.25s ease !important;
  box-shadow: none !important;
}

::v-deep .v-select .v-input__control > .v-input__slot:hover,
::v-deep .v-text-field .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 238, 90, 111), 0.4) !important;
  background: rgba(16, 16, 30, 0.48) !important;
}

::v-deep .v-select.v-input--is-focused .v-input__control > .v-input__slot,
::v-deep .v-text-field.v-input--is-focused .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 238, 90, 111), 0.15) !important;
  background: rgba(16, 16, 30, 0.58) !important;
}

::v-deep .v-select input,
::v-deep .v-select .v-select__selection,
::v-deep .v-text-field input,
::v-deep .v-text-field textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-select .v-label,
::v-deep .v-text-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-select.v-input--is-focused .v-label,
::v-deep .v-text-field.v-input--is-focused .v-label,
::v-deep .v-select.v-input--is-focused .v-icon,
::v-deep .v-text-field.v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-select .v-icon,
::v-deep .v-text-field .v-icon {
  color: rgba(var(--v-secondary-base-rgb, 238, 90, 111), 0.75) !important;
}

::v-deep .v-text-field input::placeholder,
::v-deep .v-textarea textarea::placeholder {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .v-text-field__details,
::v-deep .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .v-input--checkbox .v-label {
  color: #e0e0e0 !important;
}
</style>
